import Vue from "vue"

var VueTruncate = require("vue-truncate-filter")
Vue.use(VueTruncate)
